var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flags"},_vm._l((_vm.languages),function(lang){return _c('button',{key:lang.id,ref:lang.flag,refInFor:true,on:{"click":function($event){return _vm.changeLocale(lang)}}},[_vm._v(" "+_vm._s(lang.language.toUpperCase())+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }